import * as React from 'react'
import Img from 'components/common/Img'

const ImageGallery = ({ images }) => (
	<section className="grid md:grid-cols-[repeat(auto-fit,minmax(200px,1fr))] max-w-screen-2xl mx-auto">
		{images?.map(({ image, alt }, key) => (
			<figure key={key}>
				<Img image={image} alt={alt} />
			</figure>
		))}
	</section>
)

export default ImageGallery
